const S3_PRESIGNED_QUERY_PATTERN =
  /(?:^|[?&])x-amz-(?:algorithm|credential|signature)=/i;

export const getUnityCacheControl = (url = "") => {
  // Unity revalidates cached GET responses with HEAD. S3 presigned URLs are
  // method-bound, so a HEAD revalidation turns a valid signed GET into a 403.
  if (S3_PRESIGNED_QUERY_PATTERN.test(String(url))) {
    return "no-store";
  }

  return "must-revalidate";
};
